import { getEnvironmentVariable } from '@didaskill/utils/web';

import { sentryConfigSchema } from './schema';

/**
 * Get the runtime environment variable (`window.env`) for the given key.
 * @param key - The key to get the environment variable for.
 * @returns The environment variable for the given key.
 */
export function getServiceEnv(key: string): string | undefined {
  const service = process.env.SENTRY_SERVICE_NAME;

  if (!service) {
    return undefined;
  }

  const envKey = `${service.toUpperCase()}_${key}`;
  if (envKey.includes('ENABLED')) {
    if (getEnvironmentVariable(envKey) === undefined) {
      return getEnvironmentVariable('SENTRY_ENABLED');
    }
  }

  return getEnvironmentVariable(envKey);
}

/**
 * Load the Sentry configuration.
 * @returns The Sentry configuration.
 */
export function loadSentryConfig() {
  const { value, error } = sentryConfigSchema.validate(
    {
      dsn: getServiceEnv('SENTRY_DSN'),
      enabled: getServiceEnv('SENTRY_ENABLED'),
      env: getEnvironmentVariable('ENVIRONMENT'),
      traceSampleRate: getServiceEnv('SENTRY_TRACE_SAMPLE_RATE'),
      replaysSessionSampleRate: getServiceEnv('SENTRY_REPLAYS_SESSION_SAMPLE_RATE'),
      replaysOnErrorSampleRate: getServiceEnv('SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE'),
    },
    {
      abortEarly: false,
      allowUnknown: false,
      convert: true,
    },
  );

  if (error || !value.enabled) {
    return null;
  }
  return value;
}
